import { useEffect } from 'react';
import style from './Transcript.module.scss';
import TranscriptContent from './TranscriptContent';
import TranscriptList, { TranscriptListItem } from './TranscriptList';
import { useGetTranscriptApi } from '@/hooks/api';
import { selectVisitRecordings, useAppSelector } from '@ax/redux-store';
import { selectedTranscript } from '@/store/selectedTranscript';
import { recordingState } from '@/store/recordingState';
import { LiveAudioVisualizer } from '../../../node_modules/react-audio-visualize';
import useAudioRecorder from '@/hooks/useAudioRecorder';
import { Loader } from '@ax/ui';

interface TranscriptProps {
  readonly?: boolean;
}

const Transcript = ({ readonly }: TranscriptProps) => {
  const visitsState = useAppSelector((state) => state.selectedVisit);
  const noteId = visitsState.uuid;
  const selectedTranscriptId = selectedTranscript.value?.id ?? '';
  const isRecordingInprogress = recordingState.value.recordingInprogress;
  const transcriptList = useAppSelector(selectVisitRecordings(noteId), {
    equalityFn: (a, b) =>
      a.map((item: TranscriptListItem) => `${item.id}|${item.duration}`).join() ===
      b.map((item: TranscriptListItem) => `${item.id}|${item.duration}`).join(),
  });
  const { data: transcript, isLoading }: any = useGetTranscriptApi(noteId, selectedTranscriptId);
  const conversations: any[] = transcript?.conversations;

  const { mediaRecorder, startRecording, stopRecording, isRecording } = useAudioRecorder();

  const renderTranscriptContent = () => {
    if (!noteId || !selectedTranscriptId) {
      return renderPlaceholderContent();
    }

    if (isLoading) {
      return <Loader color="#344bc6" />;
    }

    if (conversations && !isRecordingInprogress) {
      return <TranscriptContent conversations={conversations} />;
    }

    return renderPlaceholderContent();
  };

  const renderPlaceholderContent = () => (
    <p className={style.transcript__content__placeholder}>
      <span className={style.transcript__content__placeholder__title}>
        {mediaRecorder && isRecording && (
          <LiveAudioVisualizer
            mediaRecorder={mediaRecorder}
            width={300}
            height={75}
            barWidth={3}
            gap={2}
            barColor={'#344bc6'}
          />
        )}
        {isRecordingInprogress ? 'Recording in progress' : 'No Transcripts'}
      </span>
      {!readonly && (
        <span className={style.transcript__content__placeholder__text}>
          {isRecordingInprogress
            ? 'Your draft will appear after you stop the recording.'
            : 'Create a recording to get started'}
        </span>
      )}
    </p>
  );

  useEffect(() => {
    if (isRecordingInprogress) {
      startRecording();
    } else {
      stopRecording();
    }
  }, [isRecordingInprogress, startRecording, stopRecording]);

  return (
    <div className={style.transcript__container}>
      <TranscriptList items={transcriptList} />
      {renderTranscriptContent()}
    </div>
  );
};

export default Transcript;
